export default "__VITE_ASSET__CeLgC8ov__"